<template>
  <div class="container page">
    <van-nav-bar :title="videoInfo && videoInfo.vod_name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="movie-video">
      <video v-show="useNative" id="my-video" class="video-js"></video>
      <!-- X/Twitter widgets break under a restrictive sandbox -->
      <iframe
        v-if="!useNative && embedSrc && embedType === 'twitter'"
        :src="embedSrc"
        class="embed-frame embed-frame--twitter"
        allow="autoplay; fullscreen; encrypted-media; picture-in-picture; web-share"
        allowfullscreen
        frameborder="0"
      ></iframe>
      <iframe
        v-else-if="!useNative && embedSrc"
        :src="embedSrc"
        class="embed-frame"
        allow="autoplay; fullscreen; encrypted-media; picture-in-picture; clipboard-write; accelerometer; gyroscope"
        allowfullscreen
        frameborder="0"
        sandbox="allow-scripts allow-same-origin allow-forms allow-presentation allow-popups allow-popups-to-escape-sandbox"
      ></iframe>
      <div v-if="!useNative && !embedSrc" class="loading-box">Loading video...</div>
    </div>
    <div class="movie-content">
      <div class="movie-descript">
        <p>{{ videoInfo && videoInfo.vod_name }}</p>
        <span>{{ videoInfo && videoInfo.count }}{{ $t("video.num_play") }}</span>
      </div>
      <div class="movie-body">
        <div class="movie-title">
          <div>
            <span>{{ $t("index.recmonmand") }}</span>
          </div>
        </div>
      </div>
      <div class="hotlist">
        <div v-for="(v,key) in moreVideoInfo" :key="key" @click="toPlayVideo(v.id)">
          <img :src="v.vod_pic" />
          <div>
            <span>{{ v.vod_name }}</span><span>{{$t("video.play")}}:{{ v.count }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import videojs from "video.js";
import "videojs-contrib-hls";
import { parseVideoEmbed, isHlsUrl } from "@/common/videoEmbed";

/* legacy inline parser removed — see common/videoEmbed.js */
function parseEmbed(url) {
  var hit = parseVideoEmbed(url);
  return hit ? hit.src : null;
}

export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover: "",
      userInfo: {},
      videoInfo: { vod_name: "", count: 0, vod_pic: "", vod_play_url: "" },
      moreVideoInfo: [],
      player: null,
      is_play: false,
      times: null,
      is_see: 0,
      useNative: true,
      embedSrc: "",
      embedType: ""
    };
  },
  methods: {
    back() { this.$router.push({ path: "/Video" }); },
    getVideoInfo() {
      this.$http({ method: "get", data: { id: this.$route.query.id }, url: "video_get_info" })
        .then((res) => {
          if (res && res.data) {
            this.videoInfo = res.data;
            this.nowPlayVideoUrl = res.data.vod_play_url || "";
            this.cover = res.data.vod_pic || "";
            this.setupPlayer();
          }
        });
    },
    setupPlayer() {
      var url = this.nowPlayVideoUrl || "";
      var hit = parseVideoEmbed(url);
      if (hit) {
        this.useNative = false;
        this.embedSrc = hit.src;
        this.embedType = hit.type || '';
        return;
      }
      this.useNative = true;
      this.embedSrc = "";
      var self = this;
      this.$nextTick(function () {
        if (!self.player) {
          self.player = videojs("my-video", {
            height: "200px",
            preload: "auto",
            controls: true,
            multipleArray: [0.75, 1, 1.5, 2]
          }, function () {
            this.on("play", function () { self.is_play = true; });
          });
        }
        var type = isHlsUrl(url) ? "application/x-mpegURL"
                 : /\.webm(\?|$)/i.test(url) ? "video/webm"
                 : "video/mp4";
        self.player.src([{ src: url, type: type }]);
        self.player.poster(self.cover);
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) { this.$router.push({ path: "/Login" }); return; }
      this.$router.push({ path: "?id=" + id });
      location.reload();
    },
    getMoreVideoItem() {
      this.$http({ method: "get", url: "video_get_more_item" })
        .then((res) => { this.moreVideoInfo = (res && res.data) || []; });
    },
    getUserInfo() {
      var self = this;
      this.$http({ method: "get", url: "user_info" })
        .then((res) => {
          if (res && res.code === 200) {
            self.userInfo = res.data || {};
            self.is_see = self.userInfo.is_see || 0;
            if (self.userInfo.status !== 1) {
              self.$toast(self.$t("video.account_out"));
              localStorage.clear();
              self.$router.push({ path: "/Login" });
            } else {
              self.getVideoInfo();
              self.getMoreVideoItem();
            }
          } else {
            // even if user_info fails, still load video
            self.getVideoInfo();
            self.getMoreVideoItem();
          }
        })
        .catch(() => {
          self.getVideoInfo();
          self.getMoreVideoItem();
        });
    }
  },
  mounted() {
    if (!localStorage.getItem("token")) { this.$router.push({ path: "/Login" }); return; }
    this.getUserInfo();
  },
  beforeDestroy() {
    if (this.player) { this.player.dispose(); this.player = null; }
    if (this.is_play) this.is_play = false;
    clearInterval(this.times);
  }
};
</script>

<style scoped>
.video-js { width: 100%; font-size: 24px; }
.movie-video { width: 100%; background: #000; }
.embed-frame { width: 100%; height: 56vw; max-height: 420px; min-height: 220px; border: 0; display: block; }
.embed-frame--twitter { height: min(88vh, 720px); max-height: 720px; min-height: 460px; }
.loading-box { color: #fff; padding: 30vw 0; text-align: center; font-size: 28px; }
.movie-content { flex: 1; overflow-y: auto; }
.movie-content .movie-descript { width: 100%; background-color: #fff; display: flex; flex-direction: column; align-items: flex-start; justify-content: space-between; padding: 15px; }
.movie-content .movie-descript p { font-size: 30px; font-weight: 700; color: rgb(62, 33, 134); }
.movie-content .movie-descript span { color: rgb(170, 45, 220); font-size: 0.8rem; background: rgb(242, 242, 245); padding: 10px; border-radius: 16px; }
.movie-content .movie-body { width: calc(100% - 20px); margin: 0 auto; }
::v-deep .movie-video .video-js .vjs-big-play-button { top: 50%; left: 50%; margin-top: -50px; margin-left: -100px; }
.movie-content .movie-body .movie-title { height: 70px; display: flex; align-items: center; justify-content: space-between; }
.movie-content .movie-body .movie-title > div:first-child { width: 410px; }
.movie-content .movie-body .movie-title > div:first-child span { display: flex; align-items: center; justify-content: flex-start; font-size: 30px; font-weight: 700; color: #000; }
.movie-content .movie-body .movie-title > div:first-child span:before { content: ""; display: block; width: 8px; height: 30px; background-color: #7e5678; border-radius: 25px; margin-right: 10px; }
.vjs-big-play-button .vjs-icon-placeholder { font-size: 1.63em !important; }
.hotlist { display: flex; flex-wrap: wrap; justify-content: space-between; }
.hotlist div { position: relative; width: calc(50% - 10px); border-radius: 16px; overflow: hidden; margin-bottom: 20px; }
.hotlist div img { width: 100%; height: 27vw; }
.hotlist div div { position: absolute; bottom: 20px; width: 100%; left: 0; background: rgba(0,0,0,.4); color: #fff; display: flex; align-items: center; justify-content: space-between; font-size: 3vw; height: 8vw; border-radius: 16px; }
.hotlist div div span { width: 50%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center; padding-left: 20px; }
</style>
